export interface BodyPart {
  value: string;
  name: string;
}

export const bodyParts: BodyPart[] = [
  {
    value: "FULL_BODY",
    name: "כל הגוף"
  },
  {
    value: "CUSTOM",
    name: "מותאם אישית"
  },
]
